import { FormattedMessage } from "react-intl";

import { Link, Route } from "Navigation";
import StyledTable from "components/StyledTable";
import type { Column } from "components/StyledTable";

interface Role {
  id: string;
  name: string;
}

const columns: Column<Role>[] = [
  {
    accessorKey: "name",
    header: () => (
      <FormattedMessage
        id="components.RolesTable.nameTitle"
        defaultMessage="Name"
        description="Title for the Name column of the roles table"
      />
    ),
    cell: ({ row, getValue }) => (
      <Link route={Route.rolesEdit} params={{ roleId: row.original.id }}>
        {getValue()}
      </Link>
    ),
  },
];

interface Props {
  className?: string;
  data: Role[];
  searchText?: string;
}

const RolesTable = ({ className, data, searchText }: Props) => (
  <StyledTable
    className={className}
    columns={columns}
    data={data}
    searchText={searchText}
  />
);

export default RolesTable;
